<template>
    <div class="coffee-map"></div>
</template>

<script>
    export default {
        props: {
            latitude: String,
            longitude: String,
            producer: String
        },
        data: function() {
            return {
                map: null,
                tileLayer: null,
                marker: null,
                layers: []
            }
        },
        mounted: function() {
            this.initMap();
        },
        methods: {
            initMap() {
                this.map = L.map('source-map').setView([this.latitude, this.longitude], 12);
                this.tileLayer = L.tileLayer('https://api.mapbox.com/v4/{id}/{z}/{x}/{y}.png?access_token={accessToken}', {
                    attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
                    maxZoom: 18,
                    id: 'mapbox.streets',
                    zIndex: 1,
                    accessToken: 'pk.eyJ1IjoiY3JlbWFkZXYiLCJhIjoiY2p0NG5rMzY5MnVnaDQ5b2RtanFra2NwMCJ9.rzDnUh4VEg15j04HqQ3JVA'
                });
                this.tileLayer.addTo(this.map);
                this.marker = L.marker([this.latitude, this.longitude]);
                this.marker.addTo(this.map)
                    .bindPopup(this.producer)
                    .openPopup();
            },
            initLayers() {},
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../styles/variables_home";
    @import "../../styles/common_home";
</style>
